<template>

  <div id="map-background">
    <div id="ad-view">
      <img class="ad-slide" data-type="wa" />
    </div>
    <div id="wa-view">
      <div id="title" class="container">
        <div class="row center">
          <div class="column">
            <header>
              <img class="hero-logo" v-bind:src="roomLogo" v-if="roomLogo">
              <h3 v-if="showRoomName">{{roomName}}</h3>
            </header>
          </div>
        </div>
      </div>

      <div id="canvas" class="container">
        <div class="row">
          <div class="column">
            <room ref="room"
              :roomLabelMeta="roomLabelMeta"
              :roomId="roomId"
              :gridSizePx="gridSizePx"
              :roomName="roomName"
              :roomLogo="roomLogo"
              :themeConfig="themeConfig"
            />
            <div id="bottom-controls" class="center">
              <a href="#" @click="togglePageView">Toggle compact view</a>
            </div>
          </div>
        </div>
      </div>

      <div id="status" class="container__full-width">
        <div class="container">
          <div class="row">
            <div class="column">
              <subscribe ref="subscribe" :statuses="statuses" :template="template" :canSms="roomCanSms" :themeConfig="themeConfig"></subscribe>
              <room-subscribe :template="template" :canSms="roomCanSms"></room-subscribe>
            </div>
          </div>
        </div>
      </div>

      <div id="message" class="container__full-width bg-dark">
        <div class="container">
          <div class="row">
            <div class="column">
              <service />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {
  roomsRef,
  statusesRef,
  getTemplates,
  getMachines,
  getAds,
  getDirectory
} from "../services/data";

import Room from "./Room";
import Directory from "./Directory";
import Subscribe from "./Subscribe";
import Service from "./Service";
import RoomSubscribe from "./room/RoomSubscribe";

const almostDoneThreshold = 240; // Seconds until cycle complete

function getQueryStringParameter(paramName) {
    let regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default {
  name: "Home",
  components: {
    Room,
    Directory,
    Subscribe,
    Service,
    RoomSubscribe
  },
  data() {
    return {
      roomName: "",
      roomLabelMeta: null,
      roomId: null,
      gridSizePx: 800,
      roomLogo: "",
      statuses: null,
      roomCanSms: true,
      showRoomName: false,
      adMode: false,
      themeConfig: null,
      template: {
        id: "",
        roomId: "",
        machineId: "",
        machineTimeId: ""
      },
      backgroundStyle: "",
      timerTopOffset: 0,
      timerWidthOffset: 0,
    };
  },
  beforeMount() {
    console.log('v2.5.1');
    // HACK SPECIAL ROOM GETS BIGGER GRID
    if (this.$route.query.room == 133) {
      this.gridSizePx = 840;
    } else {
      this.gridSizePx = 800;
    }
  },
  mounted() {
    let vueThis = this;

    if (window.location.href.indexOf("mode=tv") != -1) {
      $(".wrapper").addClass("tv-mode");
      getAds(this.$route.query.room).then(function(results) {
        if (results.data) {
          vueThis.loadAdSlides(results.data);
          vueThis.startAdSlideshow();
        }
      });
    }

    if (this.$route.query.compact) {
      $("#status, #message").hide();
    }
    if (this.$route.query.room) {
      const roomId = this.$route.query.room;
      const orgId = this.$route.params.orgId;

      getTemplates().then(results => {
        const data = results.data[0];
        if (!data) console.log(data); // todo: handle this?

        this.template.id = data.id;
        data.subscriptionConditionTemplates.forEach(template => {
          const type = template.subscriptionConditionType;
          switch (type.lookupKey) {
            case "ROOM_ID":
              this.template.roomId = type.id;
              break;
            case "MACHINE_ID":
              this.template.machineId = type.id;
              break;
            case "MACHINE_TIME_BEFORE_COMPLETE":
              this.template.machineTimeId = type.id;
              break;
            case "AVAILABLE_DRYER_COUNT_ABOVE":
              this.template.dryerCountAbove = type.id;
              break;
            case "AVAILABLE_WASHER_COUNT_ABOVE":
              this.template.washerCountAbove = type.id;
              break;
          }
        });
      });
      let machines = {};

      getMachines(orgId, roomId).then(results => {
        results.data.forEach(machine => {
          machines[machine.id] = {
            id: machine.id,
            controlId: machine.controlId,
            serialNumber: machine.serialNumber,
            isWasher: machine.machineType.isWasher,
            isDryer: machine.machineType.isDryer,
            machineNumber: machine.machineNumber,
            machineName: machine.machineName,
            machineDisplayName: machine.machineName && machine.machineName.length <= 8 && machine.machineName.length > 0 ? machine.machineName : machine.machineNumber.replace(/^0+/, ""),
            machineSize: machine.machineType.typeName,
            machineTypeName: machine.machineType.typeName,
            networkNode: machine.networkNode,
            washAlertScaleX: machine.washAlertScaleX,
            washAlertScaleY: machine.washAlertScaleY,
            washAlertXAxis: machine.washAlertXAxis,
            washAlertYAxis: machine.washAlertYAxis,
            washAlertAngle: machine.washAlertAngle,
            washAlertIsVisible: machine.washAlertIsVisible,
            washAlertZIndex: machine.washAlertZIndex,
            machineType: machine.machineType,
            machineAuditType: machine.machineAuditType.id,
            modelNumber: machine.modelNumber,
            statusId: "init"
          };

          // convert machine size for Australia
          if (orgId === '450828') {
            if (!machines[machine.id].isDryer && machines[machine.id].machineSize.indexOf('13.6') != -1) {
              machines[machine.id].machineSize = 'Washer Extractor 14 kg.'
            }
          }
        });

        function showElement(property, defaultValue) {
          if (property === undefined) {
            return defaultValue;
          } else {
            return property;
          }
        }

        function loadStyle(filename) {
          let cssFile = document.createElement('link');
          cssFile.rel = "stylesheet";
          cssFile.href = filename;
          document.head.appendChild(cssFile);
        }

        roomsRef
          .child(roomId)
          .once("value")
          .then(snapshot => {
            const room = snapshot.val();
            this.roomName = room.roomName;
            this.roomId = room.id;
            this.roomLogo = room.logoUrl;
            this.roomLabelMeta = room.roomLabelMeta;
            this.roomCanSms = room.canSms;
            this.showRoomName = showElement(room.hasWashAlertRoomName, true);
            this.s3ImageUrl = room.s3ImagePath;

            // Get the theme configuration
            let themeConfig;
            let theme = room.washAlertTheme || 'theme1';

            // Theme override for testing (disabled while forcing automatic theme)
            const themeOverride = getQueryStringParameter('theme');
            if (themeOverride) {
              theme = themeOverride;
            }

            $.ajax({ async: false, dataType: 'JSON', url: `/static/themes/${theme}/theme.json` })
              .done((json) => { themeConfig = json; });

            this.themeName = theme;
            this.themeConfig = themeConfig;
            if (themeConfig["use-stylesheet"]) {
              loadStyle(`/static/themes/${theme}/style.css`);
            }

            if (themeConfig["timer-top-offset"]) {
              this.timerTopOffset = themeConfig["timer-top-offset"];
            }

            if (themeConfig["timer-width-offset"]) {
              this.timerWidthOffset = themeConfig["timer-width-offset"];
            }

            // Add style to the top background of Wash Alert
            if (themeConfig && themeConfig["top-background-style"]) {
              this.backgroundStyle = themeConfig["top-background-style"];
            }

            console.log("Theme:", theme);

            // This does the initial roomUpdate/creation
            // Use $nextTick to ensure the room component is fully mounted before calling roomUpdate
            this.$nextTick(() => {
              console.log('Checking room ref:', this.$refs.room);
              console.log('All refs:', this.$refs);
              if (this.$refs.room && this.$refs.room.roomUpdate) {
                console.log('Calling roomUpdate');
                this.$refs.room.roomUpdate(room, machines, {
                  showClock: showElement(room.hasWashAlertClock, true),
                  showLegend: showElement(room.hasWashAlertLegend, true),
                  canvasResize: showElement(room.washAlertCanvasResize, false),
                  s3ImagePath: showElement(room.s3ImagePath, ""),
                  themeConfig: themeConfig,
                });
              } else {
                console.error('Room component ref not available');
              }
            });
            // no SMS for Australia
            if (orgId === '450828') {
              this.roomCanSms = false;
            }

            // This is used to monitor the status of the machines
            statusesRef
              .orderByChild("roomId")
              .equalTo(this.roomId.toString())
              .on("value", snap => {
                // This anonymous function is called when data is initially loaded and every time the data changes.
                snap.forEach(childSnap => {
                  const key = childSnap.key;
                  const value = childSnap.val();

                  // Do not update if the machine is not in the array of machines
                  if (!machines[key]) {
                    return;
                  }

                  // Do not update if the receivedAt hasn't changed since the last update
                  if (value.receivedAt == machines[key].receivedAt) {
                    return;
                  }

                  machines[key].hasUpdate = true; // Flag update for the room component
                  machines[key].receivedAt = value.receivedAt;
                  machines[key].isDoorOpen = value.isDoorOpen;
                  machines[key].networkNode = machines[key].networkNode;
                  machines[key].remainingSeconds = value.remainingSeconds;

                  // Transform IN_USE to ALMOST_DONE when remaining time is less than 4 minutes (240 seconds)
                  let statusId = value.statusId ? value.statusId.toLowerCase() : '';
                  if (statusId === 'in_use' && value.remainingSeconds && value.remainingSeconds < almostDoneThreshold) {
                    statusId = 'almost_done';
                  }
                  machines[key].statusId = statusId;

                  machines[key].statusMonitorUpdatedAt = value.statusMonitorUpdatedAt;
                });

                this.$set(this, "statuses", machines);
                // Use $nextTick to ensure components are fully mounted before calling methods
                this.$nextTick(() => {
                  if (this.$refs.room && this.$refs.room.machineUpdate) {
                    this.$refs.room.machineUpdate(machines); // Reaches down into the room component and updates the machines
                  }
                  if (this.$refs.subscribe && this.$refs.subscribe.updateStatus) {
                    this.$refs.subscribe.updateStatus();
                  }
                });
              });
            });

        // setup analytics now that we have org and room info
        let enableGa = () => {
          vueThis.$ga.enable();
          let org = results.data[0].organization;
          let room = results.data[0].room;

          // Override page url - changing this after the initial push to prod will cause a schism and discontinuity of the data in google analytics
          let pageUrl = 'Org:' + org.id + ' ' + org.organizationName;
          // These 3 set's apply to all every single event/pageview from here on out
          vueThis.$ga.set('dimension1', 'Org:' + org.id  + ' ' + org.organizationName);
          vueThis.$ga.set('dimension2', 'Room:' + room.id + ' ' + room.roomName);
          vueThis.$ga.set('page', pageUrl); // set url for all events
          vueThis.$ga.page(pageUrl); // fire page view
          console.log('event:pageview');
        };
        let enabledIfHasConsented = function() {
          if (this.hasConsented()) {
            enableGa();
          } else {
            vueThis.$ga.disable();
          }
        };

        // hide cookie banner for tv mode
        if (window.location.href.indexOf("mode=tv") == -1) {
          window.cookieconsent.initialise({
            // customize here: https://cookieconsent.insites.com/download/
            palette: {
              popup: {
                background: "#eaf7f7",
                text: "#5c7291"
              },
              button: {
                background: "#56cbdb",
                text: "#ffffff"
              }
            },
            theme: "classic",
            position: "top",
            type: "opt-in",
            location: true,
            onNoCookieLaw: function() {
              enableGa();
            },
            onStatusChange: enabledIfHasConsented,
            onRevokeChoice: enabledIfHasConsented
          });
        }
      });
    } else {
      this.$set(this, "roomName", "Need a valid room.");
    }
  },
  methods: {
    togglePageView(e) {
      e.preventDefault();

      if ($("#status").is(":visible")) {
        $("#status, #message").hide();
      } else {
        $("#status, #message").show();
      }
    },

    loadAdSlides(slides) {
      var slideshow = $("#ad-view");

      if (slides && slides.length > 0) {
        slideshow.empty();
      }

      slides.forEach(function(slide) {
        var slideImg = $("<img />");

        slideImg.addClass("ad-slide");
        slideImg.attr("data-type", slide.advertisementTypeLookupKey == "WASH_ALERT" ? "wa" : "ad");
        slideImg.attr("src", slide.imageUrl);
        slideImg.attr("data-backgroundcolor", slide.background);
        slideImg.attr("data-duration", slide.duration);

        slideshow.append(slideImg);
      });
    },

    toggleAdMode(e) {
      e.preventDefault();

      if (this.adMode) {
        this.endAdSlideshow();
      } else {
        this.startAdSlideshow();
      }
    },

    startAdSlideshow() {
      var self = this;
      var firstSlide = $(".ad-slide:first");
      var duration = firstSlide.data("duration") * 1000 || 5000;

      if (firstSlide.data("type") === "wa") {
        $("#ad-view").hide();
        $("#wa-view").hide().removeClass("hide").show();
      } else {
        $("#wa-view").hide().addClass("hide").show();
        $("#ad-view").show();
      }

      firstSlide.show().addClass("active");

      this.adMode = setTimeout(function() {
        self.showNextSlide();
      }, duration);
    },

    endAdSlideshow() {
      clearTimeout(this.adMode);

      $("#ad-view").hide();
      $("#wa-view").hide().removeClass("hide").show();
      $(".ad-slide").hide().removeClass("active");

      this.adMode = false;
    },

    showNextSlide() {
      clearTimeout(this.adMode);

      var self = this;
      var currentSlide = $(".ad-slide.active");
      var nextSlide = currentSlide.next(".ad-slide");

      if (nextSlide.length === 0) {
        nextSlide = $(".ad-slide:first");
      }

      var duration = nextSlide.data("duration") * 1000 || 5000;

      if (currentSlide.data("type") === "wa" && nextSlide.data("type") !== "wa") {
        $("#wa-view").hide("slide", {direction: "left"}, function() {
          $("#ad-view").show("slide", {direction: "right"});
        }).addClass("hide").show();
      } else if (currentSlide.data("type") !== "wa" && nextSlide.data("type") === "wa") {
        $("#ad-view").hide("slide", {direction: "left"}, function() {
          $("#wa-view").hide().removeClass("hide").show("slide", {direction: "right"});
        });
      }

      $("#ad-view").css("background", nextSlide.data("backgroundcolor") || "");

      currentSlide.removeClass("active").hide("slide", {direction: "left"}, function() {
        nextSlide.show("slide", {direction: "right"}).addClass("active");
      });

      this.adMode = setTimeout(function() {
        self.showNextSlide();
      }, duration);
    }
  }
};
</script>

<style scoped>
header {
  margin: 1em;
}
.center {
  text-align: center;
}
.hero-logo {
  max-width: 100px;
  max-height: 100px;
}
</style>
<style>
#ad-view {
  display: none;
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}
.hide {
  position: absolute;
  left: -10000px;
}
.ad-slide {
  display: none;
  position:  absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  text-align: center;
  margin: 0 auto;
  object-fit: contain;
}

.tv-mode #title, .tv-mode #bottom-controls, .tv-mode #status, .tv-mode #message {
  display: none;
}

.tv-mode .canvas-container {
  margin: 0;
}

.tv-mode .lower-canvas, .tv-mode .upper-canvas {
  max-height: 800px !important;
  max-width: 800px !important;
}

.tv-mode #canvas {
  padding: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue